import { Group } from "@mantine/core"
import { Button, Select } from "@tfg/ui"
import { useContext, useState } from "react"

import { useCreateOperationChainItemMutation } from "~/pages/Admin/Ingestion/OpChains/hooks/useCreateOperationChainItemMutation"
import { OpChainContext } from "~/pages/Admin/Ingestion/OpChains/store/op-chain-context"

export function OpChainItemCreation() {
  const { opChainIdSelected, activities } = useContext(OpChainContext)
  const [activitySelected, setActivitySelected] = useState<string | null>(null)

  const { mutate: createOpChainItem } = useCreateOperationChainItemMutation()

  const activitiesName = activities.map((activity) => activity.name).sort()

  function handleSelectActivity(value: string | null) {
    setActivitySelected(value)
  }

  function handleAddActivity() {
    const activity = activities.find(
      (activity) => activity.name === activitySelected
    )
    if (!activity || !opChainIdSelected) {
      return
    }

    createOpChainItem({
      data: {
        operationChainId: opChainIdSelected,
        activityId: activity.id,
      },
    })
  }

  return (
    <Group>
      <Select
        data={activitiesName}
        value={activitySelected}
        onChange={handleSelectActivity}
      />
      <Button onClick={handleAddActivity}>Add an activity</Button>
    </Group>
  )
}
